import React from "react";
import Hero from "./Hero";
import "./home-style.css";
import CardSection from "./CardSection";
import MeetFlxDeck from "./MeetFlxDeck";
import WhyFlxDeck from "./WhyFlxDeck";
import Steps from "./Steps";
import Testimonial from "./Testimonial";
import FAQ from "./FAQ";
import Contact from "./Contact";
import Navbar from "./Navbar";

const Home = () => {
  return (
    <div className="homepage">
      <Navbar />
      <Hero />
      <CardSection />
      <MeetFlxDeck />
      <WhyFlxDeck />
      <Steps />
      <Testimonial />
      <FAQ />
      <Contact />
    </div>
  );
};

export default Home;
